export default "__VITE_ASSET__BAOMYKCV__"